"use client"

import UpgradeTable from "@/components/upgradeDomain/UpgradeTable"
import { DomainSchema } from "@/schemas/domain.schema"
import { getNormalDomains } from "@/services/domains.service"
import { useEffect, useState } from "react"
import { z } from "zod"

export default function UpgradePage() {
    const [domains, setDomains] = useState<z.infer<typeof DomainSchema>[]>([]);

    const fetchDomains = async () => {
        const domains = await getNormalDomains();
        setDomains(domains);
    }

    useEffect(() => {
        fetchDomains();
    }, []);
    return <UpgradeTable domains={domains}>

        </UpgradeTable>
}